// firebase-upload-adapter.ts
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';

// Interface do CKEditor 5 para o objeto Loader
interface CKEditorLoader {
  file: Promise<File>;
}

export class FirebaseUploadAdapter {
  private loader: CKEditorLoader;
  private storage: AngularFireStorage;
  private storagePath: string;

  constructor (loader: CKEditorLoader, storage: AngularFireStorage, path: string) {
    this.loader = loader;
    this.storage = storage;
    this.storagePath = path;
  }

  /**
   * Inicia o processo de upload.
   * Deve retornar uma Promise que resolve com o URL da imagem carregada.
   */
  async upload (): Promise<any> {
    return this.loader.file.then(file => {
      return new Promise((resolve, reject) => {
        const filePath = this.storagePath + `/${ Date.now() }_${ file.name }`;
        const storageRef = this.storage.ref(filePath);
        const uploadTask = this.storage.upload(filePath, file);

        // Monitora o progresso do upload
        uploadTask.percentageChanges().subscribe(percentage => {
          // O CKEditor tem um método 'change' no loader, mas é opcional.
          // Se quiser mostrar a barra de progresso, você pode usar:
          // this.loader.uploaded = (percentage / 100) * file.size;
        });

        // Monitora o estado final do upload
        uploadTask.snapshotChanges().pipe(
          finalize(async () => {
            try {
              // Obtém a URL pública do arquivo
              const downloadURL = await storageRef.getDownloadURL().toPromise();

              // RESOLVE A PROMISE com o objeto que o CKEditor espera
              resolve({
                default: downloadURL
              });
            } catch (error) {
              reject(error);
            }
          })
        ).subscribe(
          null,
          error => reject(`Upload failed: ${ error.message }`)
        );
      });
    });
  }

  /**
   * Aborta o processo de upload (opcional).
   */
  abort (): void {
    // Implementar a lógica de cancelamento do Firebase se necessário
    console.log('Upload abortado.');
  }

}

/**
 * Função que injeta o adaptador no CKEditor.
 */
export function FirebaseUploadAdapterPlugin (editor: any, storage: AngularFireStorage) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader: CKEditorLoader) => {
    // Retorna uma nova instância do seu adaptador, passando o FileLoader do CKEditor
    // e o serviço de Storage injetado do Angular.
    return new FirebaseUploadAdapter(loader, storage, this.storagePath );
  };
}
